import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './utils';

export const locationApis = createApi({
  reducerPath: 'locationApis',
  baseQuery: baseQueryWithReauth,

  // Important: add tag types you'll use for cache invalidation
  tagTypes: ['Location', 'ExtraPincode', 'ExtraPincodeList'],

  endpoints: (builder) => ({
    // ── Existing ────────────────────────────────────────────────────────
    getStateList: builder.query({
      query: () => `getState`,
      providesTags: ['Location'],
    }),

    getCityList: builder.query({
      query: (stateId) => `getCity/${stateId}`,
      providesTags: ['Location'],
    }),

    createPincode: builder.mutation({
      query: (data) => {
        console.log('Location API - Sending payload:', data);
        return {
          url: `CreatePincode`,
          method: 'POST',
          body: data,
        };
      },
      invalidatesTags: ['ExtraPincodeList', 'ExtraPincode'],
    }),

    // ── New: Get all extra pincodes for a specific city ─────────────────
    getExtraPincodesByCity: builder.query({
      // NOTE: Backend route name follows existing convention used in SubAdmin.js
      // e.g. `GetExtraPincodeByCity/:cityId`
      query: (cityId) => `GetExtraPincodeByCity/${cityId}`,
      providesTags: (result, error, cityId) =>
        result?.data
          ? [
              'ExtraPincodeList',
              ...result.data.map(({ id }) => ({ type: 'ExtraPincode', id })),
              { type: 'ExtraPincodeList', id: cityId }, // per-city tag (optional)
            ]
          : ['ExtraPincodeList'],
    }),

    // ── New: Delete a single extra pincode by its ID ────────────────────
    deleteExtraPincode: builder.mutation({
      query: (pincodeId) => ({
        // Backend controller method: DeleteExtraPincode
        // Route is expected to be `DeleteExtraPincode/:id`
        url: `DeleteExtraPincode/${pincodeId}`,
        method: 'DELETE',
      }),
      // Invalidate list + the specific item
      invalidatesTags: (result, error, pincodeId) => [
        { type: 'ExtraPincode', id: pincodeId },
        'ExtraPincodeList',
      ],
    }),

    // Optional: If you later want a bulk-replace endpoint (delete old + insert new in one call)
    // replacePincodesForCity: builder.mutation({...})
  }),
});

export const {
  useGetStateListQuery,
  useGetCityListQuery,
  useCreatePincodeMutation,
  useGetExtraPincodesByCityQuery,
  useDeleteExtraPincodeMutation,
  // useReplacePincodesForCityMutation, // if added later
} = locationApis;